import localforage from "localforage";

class StorageService {

    private static instance: StorageService;
    private constructor() { }

    public static getInstance(): StorageService {
        if (StorageService.instance === undefined) {
            StorageService.instance = new StorageService();
        }
        return StorageService.instance;
    }

    setItem(key: string, item: any) {
        localforage.setItem(key, item);
    }

    getItem(key: string) {
        return localforage.getItem(key);
    }
    getItemByLocalstorage(user: string) {
        return localStorage.getItem(user);
    }

    setItemByLocalStorage(key: string, item: any) {
        // TODO: crypto js - encrypt the item
        localStorage.setItem(key, item)
    }

}

export const storageService: StorageService = StorageService.getInstance();